import { combineReducers } from 'redux';
import benchmarkStoreReducer from './comparison-benchmarks-store';
import savedBenchmarksReducer from './saved-benchmarks';
import benchmarkPortfoliosReducer from './benchmark-portfolios';

export default combineReducers({
  savedBenchmarks: savedBenchmarksReducer,
  store: benchmarkStoreReducer,
  benchmarkPortfolios: benchmarkPortfoliosReducer,
});
